import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { homeTabs } from '../../../routes/purchases';

const Home = () => {
  const tabs = homeTabs();
  return <FingoPaper tabs={tabs} />;
};

export default Home;
